import { render, staticRenderFns } from "./MyFavourite.vue?vue&type=template&id=4383ef0d&"
import script from "./MyFavourite.vue?vue&type=script&lang=js&"
export * from "./MyFavourite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports